import React, { useCallback } from 'react';

import { useFreecodeContextData } from 'hooks/useContext';
import FreecodeText from './FreecodeText';

export default function FreecodeFlow() {
  const { testImpl, setTestImpl } = useFreecodeContextData();

  const updateFlow = useCallback(
    (value) => {
      setTestImpl((oldTestImpl) => ({ ...oldTestImpl, flow: value }));
    },
    [setTestImpl]
  );

  return <FreecodeText text={testImpl?.flow} textRaw={testImpl?.flow} textRawEdit={updateFlow} />;
}
